import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=149a38fe&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=149a38fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149a38fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('149a38fe')) {
      api.createRecord('149a38fe', component.options)
    } else {
      api.reload('149a38fe', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=149a38fe&scoped=true&", function () {
      api.rerender('149a38fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-45lgL9Rav6Nn2/JS/comp/GuestBox.vue"
export default component.exports